import enAdmin from './locales/en/admin.json';
import enAuth from './locales/en/auth.json';
import enAutopilot from './locales/en/autopilot.json';
import enCommon from './locales/en/common.json';
import enCompany from './locales/en/company.json';
import enCredits from './locales/en/credits.json';
import enFixedRoutes from './locales/en/fixedRoutes.json';
import enLicensing from './locales/en/licensing.json';
import enMap from './locales/en/map.json';
import enMapCore from './locales/en/mapCore.json';
import enMapDialogs from './locales/en/mapDialogs.json';
import enMapDownload from './locales/en/mapDownload.json';
import enMapTransfer from './locales/en/mapTransfer.json';
import enMapWizards from './locales/en/mapWizards.json';
import enNavigation from './locales/en/navigation.json';
import enOnboarding from './locales/en/onboarding.json';
import enProfile from './locales/en/profile.json';
import enSharing from './locales/en/sharing.json';
import enSimulation from './locales/en/simulation.json';
import enTools from './locales/en/tools.json';
import enWhatsNew from './locales/en/whatsNew.json';

import ptBRAdmin from './locales/pt-BR/admin.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRAutopilot from './locales/pt-BR/autopilot.json';
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRCompany from './locales/pt-BR/company.json';
import ptBRCredits from './locales/pt-BR/credits.json';
import ptBRFixedRoutes from './locales/pt-BR/fixedRoutes.json';
import ptBRLicensing from './locales/pt-BR/licensing.json';
import ptBRMap from './locales/pt-BR/map.json';
import ptBRMapCore from './locales/pt-BR/mapCore.json';
import ptBRMapDialogs from './locales/pt-BR/mapDialogs.json';
import ptBRMapDownload from './locales/pt-BR/mapDownload.json';
import ptBRMapTransfer from './locales/pt-BR/mapTransfer.json';
import ptBRMapWizards from './locales/pt-BR/mapWizards.json';
import ptBRNavigation from './locales/pt-BR/navigation.json';
import ptBROnboarding from './locales/pt-BR/onboarding.json';
import ptBRProfile from './locales/pt-BR/profile.json';
import ptBRSharing from './locales/pt-BR/sharing.json';
import ptBRSimulation from './locales/pt-BR/simulation.json';
import ptBRTools from './locales/pt-BR/tools.json';
import ptBRWhatsNew from './locales/pt-BR/whatsNew.json';

export const resources = {
  en: {
    admin: enAdmin,
    auth: enAuth,
    autopilot: enAutopilot,
    common: enCommon,
    company: enCompany,
    credits: enCredits,
    fixedRoutes: enFixedRoutes,
    licensing: enLicensing,
    map: enMap,
    mapCore: enMapCore,
    mapDialogs: enMapDialogs,
    mapDownload: enMapDownload,
    mapTransfer: enMapTransfer,
    mapWizards: enMapWizards,
    navigation: enNavigation,
    onboarding: enOnboarding,
    profile: enProfile,
    sharing: enSharing,
    simulation: enSimulation,
    tools: enTools,
    whatsNew: enWhatsNew,
  },
  'pt-BR': {
    admin: ptBRAdmin,
    auth: ptBRAuth,
    autopilot: ptBRAutopilot,
    common: ptBRCommon,
    company: ptBRCompany,
    credits: ptBRCredits,
    fixedRoutes: ptBRFixedRoutes,
    licensing: ptBRLicensing,
    map: ptBRMap,
    mapCore: ptBRMapCore,
    mapDialogs: ptBRMapDialogs,
    mapDownload: ptBRMapDownload,
    mapTransfer: ptBRMapTransfer,
    mapWizards: ptBRMapWizards,
    navigation: ptBRNavigation,
    onboarding: ptBROnboarding,
    profile: ptBRProfile,
    sharing: ptBRSharing,
    simulation: ptBRSimulation,
    tools: ptBRTools,
    whatsNew: ptBRWhatsNew,
  },
} as const;

export type SupportedLanguage = keyof typeof resources;
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'pt-BR'];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
